/*
color options : 
	 'light.purple'		'dark.purple'
	 'light.blue'		  'dark.blue'
	 'light.green'		'dark.green'
	 'light.orange'		'dark.orange'
	 'light.red'		  'dark.red'
*/
// Load Bootstrap and application modules first, then apply the fixed AKSCHAP
// theme as the final CSS layer. The literal import keeps Webpack from
// compiling every unused template colour.
import('./assets/css/sass/themes/gogo.light.red.scss').then(() => {
  require('./App');
});
